<!--  -->
<template>
  <div>
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input v-model="obr.nickname" clearable style="width:400px;margin:0 10px" placeholder="请输入名称" />
        <!-- <el-input v-model="query.keywords" clearable style="width:400px;margin:0 10px" placeholder="请输入员工id/员工编号" /> -->
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      max-height="550"
    >
      <el-table-column
        prop="wx_id"
        label="微信id"
        align="center"
        min-width="300"
      >
        <!-- <template slot-scope="scope">{{ scope.row }}
        </template> -->
      </el-table-column>
      <el-table-column
        prop="name"
        label="名字"
        align="center"
        min-width="150px"
      >
        <template slot-scope="scope">
          <el-badge v-if="scope.row.hasBadge" value="原群主" class="item">
            <span>{{ scope.row.name }}</span>
          </el-badge>
          <span v-else size="small"> <span>{{ scope.row.name }}</span></span>
        </template>

      </el-table-column>
      <el-table-column
        prop="employee_no"
        label="员工id"
        align="center"
        min-width="300px"
      />

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    /> -->

  </div>
</template>

<script>
// import PaginationRight from '@/components/PaginationRight/index.vue'
import { getEmployeeNoFriend } from '@/api/officialaccount.js'
export default {
  // components: { PaginationRight },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null,
        onlyMe: null,
        corp_keywords: null
        // user_id: null,
        // corp_id: null
      },
      obr: {
        corp_id: null,
        employee_no: null,
        nickname: null
      },
      rowlist: {},
      name: ''
    }
  },
  created() {
    // this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      this.loading = true
      const data = await getEmployeeNoFriend(this.obr)
      this.tableData = data.data
      console.log('tableData:', this.tableData)
      this.loading = false
      this.tableData.forEach((v) => {
        if (v.name === this.name) {
          v.hasBadge = true
        } else {
          v.hasBadge = false
        }
      })
    },
    open(onlyMe, item, name) {
      this.name = name
      console.log('onlyMe, item, name:', onlyMe, item, name)
      this.rowlist = item
      this.obr.corp_id = item.corp_id
      this.obr.employee_no = item.employee_no
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.obr.nickname = null
      this.query.keywords = null
      this.query.corp_keywords = null
      // this.query.user_id = null
      this.list()
    },
    choose(item) {
      if (item.name === this.name) {
        this.$message.error('请更换群主')
        return
      }
      console.log('item:', item)
      this.$emit('spWork', item)
      this.name = ''
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.item {
  margin-top: 10px;
  /* margin-right: 40px; */
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box{
  text-align: center;
}
</style>
